import { instanceApi } from '@/services/ProviderService'

export default {
    getProduct(productCode){
        return instanceApi().get(`/api/product/${productCode}`).then(res => res.data);
    }
}
